import React from 'react'
import I18n from 'i18n'
import Field from '../common/Field'

export default class SportProProfiel extends React.Component {
  render () {
    const values = this.props.data.values

    return (
      <>
        <div className='sport-fields'>
          <Field title={I18n.t('questionnaires.sportpro_profiel.consent')} value={values.consent ? I18n.t('general.yes') : I18n.t('general.no')} />
          {values.birth_year && (
            <Field title={I18n.t('questionnaires.sportpro_profiel.birth_year')} value={values.birth_year} />
          )}
          {values.gender && (
            <Field title={I18n.t('questionnaires.sportpro_profiel.gender')} value={values.gender} />
          )}
          {values.highest_education && (
            <Field title={I18n.t('questionnaires.sportpro_profiel.highest_education')} value={values.highest_education} />
          )}
          {values.relevant_education && (
            <Field title={I18n.t('questionnaires.sportpro_profiel.relevant_education')} value={values.relevant_education} />
          )}
          {values.experience_specific_role && (
            <Field title={I18n.t('questionnaires.sportpro_profiel.experience_specific_role')} value={values.experience_specific_role} />
          )}
          {values.experience_total && (
            <Field title={I18n.t('questionnaires.sportpro_profiel.experience_total')} value={values.experience_total} />
          )}
          {values.employer && (
            <Field title={I18n.t('questionnaires.sportpro_profiel.employer')} value={values.employer} />
          )}
          {values.job_title && (
            <Field title={I18n.t('questionnaires.sportpro_profiel.job_title')} value={values.job_title} />
          )}
          {values.employment_scope && (
            <Field title={I18n.t('questionnaires.sportpro_profiel.employment_scope')} value={values.employment_scope} />
          )}
          {values.funding_sources && (
            <Field title={I18n.t('questionnaires.sportpro_profiel.funding_sources')} value={Array.isArray(values.funding_sources) ? values.funding_sources.join(', ') : values.funding_sources} />
          )}
          {values.work_location && (
            <Field title={I18n.t('questionnaires.sportpro_profiel.work_location')} value={values.work_location} />
          )}
          {values.main_assignments && (
            <Field title={I18n.t('questionnaires.sportpro_profiel.main_assignments')} value={Array.isArray(values.main_assignments) ? values.main_assignments.join(', ') : values.main_assignments} />
          )}
          {values.additional_context && (
            <Field title={I18n.t('questionnaires.sportpro_profiel.additional_context')} value={values.additional_context} />
          )}
        </div>
      </>
    )
  }
}
